<template>
    <router-view />
</template>

<script>
import AOS from 'aos';
import '@/styles/main.scss';

export default {
    name: 'MainApp',
    components: {},
    created() {
        AOS.init({
            offset: 200,
            speed: 1000,
        });
    },
    methods: {
        changeLanguage(lang) {
            this.$i18n.locale = lang; // 선택한 언어로 변경
        },
    },
};
</script>
